import { captureTrackingParams } from './src/utils/tracking'

// utm_* / gclid live in the landing URL only — the first client-side navigation
// drops the query string — so they are persisted before anything else runs.
export const onClientEntry = () => {
  captureTrackingParams()
}

export const onInitialClientRender = () => {
  document.documentElement.style.visibility = 'visible'
}

// ScrollSmoother owns the window scroll position, and the floor-plans list scrolls
// inside its own container under a sticky header — Gatsby's built-in scrollIntoView()
// for #hash links fights both. Pages handle their own anchors instead.
export const shouldUpdateScroll = ({ routerProps: { location } }) => !location.hash
